import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import { omit } from 'lodash';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';

type Props = {
  classes: Object,
  className?: string,
  children?: any,
};

const defaultProps = {
  className: '',
  children: undefined,
};

function FriendDetailsContent({
  classes,
  className,
  children,
  ...otherProps
}: Props) {
  return (
    <AnimatedGroup
      {...omit(otherProps, 'sheet')}
      className={classNames(classes.content, className)}
      onEnter={Enter.appear(0.3, 0.3)}
      onLeave={Leave.disappear(0.3)}
    >
      {children}
    </AnimatedGroup>
  );
}

FriendDetailsContent.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    content: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'auto',
      position: 'relative',
      background: theme.color.basis6,
    },
  };
}

export default useSheet(applyStyles)(FriendDetailsContent);
